import * as yup from 'yup';

export const validatePhoneNumber = yup
  .string()
  .nullable()
  .trim()
  .matches(/^[\d]+$/, 'Telefonnummer får endast innehålla nummer');
